export default __webpack_public_path__ + "static/media/na.7c008251.png";